import { buyDonate, IDonate } from '../../api/donate'
import React, { useState } from 'react'
import { Modal, Typography } from 'antd'
import { signOut } from '../../api/signIn'
import { routePathSignIn } from './SignIn'
import { useHistory } from 'react-router'

interface IProps {
	donate: IDonate
	visible: boolean
	onClose: () => void
}

export const DonateCardModal = ({ donate, visible, onClose }: IProps): React.ReactElement => {
	const [loading, setIsLoading] = useState(false)
	const history = useHistory()

	const handleOk = async () => {
		const res = await buyDonate(donate.productCode)

		setIsLoading(false)

		if (res.success) {
			window.location.href = res.link
		} else {
			await signOut()
			history.push(routePathSignIn)
		}
	}

	return (
		<Modal
			width={612}
			visible={visible}
			title={`${donate.product} (${donate.price}₽)`}
			okText="Купить"
			cancelText="Закрыть"
			okButtonProps={{ loading }}
			cancelButtonProps={{ disabled: loading }}
			closable={!loading}
			onCancel={onClose}
			onOk={() => {
				setIsLoading(true)
				void handleOk()
			}}
		>
			<div style={{
			    display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center'
			}}>
				<img src={donate.descriptionImage}/>

				<div style={{ margin: '2% 0 2% 0' }}>
					{
						donate.description
							.split('\n')
							.map((str, index) =>
								<Typography key={index} style={{ margin: 0 }}>{str}</Typography>
							)
					}
				</div>
			</div>
		</Modal>
	)
}
